export default {
  "": {
    "id": 29,
    "temp_key": "",
    "site_id": 13153,
    "name": "",
    "items": [
      {
        "id": "kxyz6d66wg9w",
        "use": "page",
        "name": "O nás",
        "page": "/o-nas",
        "section": null
      },
      {
        "id": "wk0dm2a32cs",
        "use": "page",
        "name": "Menu",
        "page": "/",
        "section": "denni-menu"
      },
      {
        "id": "8uv5z7xi0jl8",
        "use": "page",
        "name": "Cukrárna",
        "page": "/cukrarna"
      },
      {
        "id": "r2t2k2tbxg7r",
        "use": "page",
        "name": "Galerie",
        "page": "/galerie"
      },
      {
        "id": "k36patel24u1",
        "use": "page",
        "name": "Kontakt",
        "page": "/kontakt",
        "section": "2eg7gbexbjp"
      }
    ]
  }
}